<template lang='pug'>
  .monitoring-item(:class='{ active: isActive, standalone: standalone }', @click='$emit("open")')
    .head
      .cat-column.text-center
        h3(v-if="standalone") {{ 'fpui.monitoring.cpu' | translate}}
        status-bar(
          :value="getKey('resources.cpu.value')",
          :min="0",
          :max="getKey('resources.cpu.limit')",
          :active="active",
          :status="getKey('resources.cpu.state')",
          :info="getCores(getKey('resource.cpu.value'))"
        )
      .cat-column.text-center
        h3(v-if="standalone") {{ 'fpui.monitoring.memory' | translate}}
        status-bar(
          :value="getKey('resources.memory.value')",
          :min="0",
          :max="getKey('resources.memory.limit')",
          :active="active",
          :status="getKey('resources.memory.state')",
          :info="getKey('resources.memory.value') | Bytes"
        )
      .cat-column.text-center
        h3(v-if="standalone") {{ 'fpui.monitoring.data_processing' | translate}}
        status-data-processing(
          :in-value="getKey('resources.dataProcessing.received')",
          :out="getKey('resources.dataProcessing.sent')",
          :active="active",
          :standalone='standalone'
        )
      .cat-column.text-center
        h3(v-if="standalone") {{ 'fpui.monitoring.data_storage' | translate}}
        status-bar(
          :value="getKey('resources.storage.value')",
          :min="0",
          :max="getKey('resources.storage.limit')",
          :active="active",
          :status="getKey('resources.storage.state')",
          :info="getBytes(getKey('resources.storage'))"
        )
      .cat-column.text-center
        h3(v-if="standalone") {{ 'fpui.monitoring.fpu' | translate}}
        status-fpu(:fpu="fpu", :service="label")
      .monitoring-item-action-container(v-if='!open')
        i.fpui.fpui-dots.text-blue.pointer(:class='{ disabled: isLimited }', @click='openEdit()', v-tooltip='isLimitedTooltip')
    monitoring-item-fpu-editor(v-if='open', :value='value', @input='updateDefaultFpu' :label='label' @close='closeEdit()', :fpapi='fpapi')
</template>

<script>
import get from 'lodash/get'
import Bytes from '@/shared/filters/Bytes'
import StatusBar from './StatusBar'
import StatusFpu from './StatusFpu'
import StatusDataProcessing from './StatusDataProcessing'
import MonitoringItemFpuEditor from './MonitoringItemFpuEditor'

export default {
  components: { StatusBar, StatusFpu, StatusDataProcessing, MonitoringItemFpuEditor },
  props: {
    value: { required: true },
    index: { type: Number },
    active: { type: Boolean, default: true },
    label: { type: String },
    standalone: { type: Boolean, default: true },
    instances: { type: Array },
    fpapi: { type: Object, required: true }
  },
  data () {
    return {
      open: false,
      defaultFpu: null
    }
  },
  computed: {
    isActive () { return typeof active === 'undefined' || this.active === true },
    // TODO add isLimited handle
    isLimited () { return false },
    isLimitedTooltip () { return '' },
    fpu () { return this.defaultFpu || (this.value && this.value.budget && this.value.budget.fpu) || {} }
  },
  methods: {
    updateDefaultFpu (e) {
      this.defaultFpu = { value: e.fpu, instances: e.instances }
    },
    openEdit () {
      if (!this.isLimited) this.open = true
    },
    closeEdit () {
      this.open = false
    },
    getCores (value) {
      if (value) {
        return `${value || 0} Core('s')`
      }
      return '0 Core'
    },
    getKey (key) { return get(this.value, key) },
    getBytes (obj) { return `${Bytes(obj && obj.value)}/${Bytes(obj && obj.limit)}` }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

.monitoring-item {
  border-top: 1px solid #dfdfdf;
  padding: 0 15px;
  padding-right: 0;
  position: relative;
  max-height: 100px;
  transition: max-height 700ms ease-in-out, padding 300ms ease-in-out;
  overflow: hidden;

  .head {
    position: relative;
    line-height: normal;
    .monitoring-item-action-container {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 20px;
      i.disabled {
        color: @grey;
        cursor: not-allowed;
      }
    }
  }
  .cat-column {
    display: inline-block;
    width: 8%;
    vertical-align: middle;
    margin-left: 7%;
    &.name {
      width: 23%;
      margin-left: 0;
      img {
        height: 60px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
      }
      h3 {
        vertical-align: middle;
        display: inline-block;
        text-transform: uppercase !important;
      }
    }
  }
  &:not(.active):hover {
    background-color: fade(@blue,15%);
    cursor: pointer;
  }
  &:nth-of-type(2) {
    border-top: none;
  }
  &.active {
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
    padding: 10px 15px;
    padding-right: 0;
    border-top: none;
    height: auto;
    max-height: 5000px;
    .cat-column.name {
      margin-top: 30px;
    }
    &+.monitoring-item {
      padding-top: 5px;
      border-top: none;
      &+.monitoring-item {
        padding-top: 0;
        border-top: 1px solid #dfdfdf;
      }
    }
  }
  &.standalone {
    box-shadow: none;
    .name {
      vertical-align: top;
      width: 15%;
    }
    .cat-column {
      width: 12%;
    }
    h3 {
      padding-top: 10px;
      margin:0 auto;
      font-size: 17px!important;
      text-transform: uppercase !important;
    }
    .head .monitoring-item-action-container {
      top: 60%;
    }
  }
}

</style>
